import React from "react";
import { Label, initializeIcons } from "office-ui-fabric-react";
import { Grid, Row, Col } from "react-flexbox-grid";

import { 
  validarVisa, retrieveQueryParams, generarSessionPagoVisa, generarPension,
  generarBotonPagoVisa, generarFormPagoVisa, verificarExistenciaCIP, obtenerPagoEfectivo, obtenerPago
} from "../helpers";
import { ExistePagoEfectivo, PagarPagoEfectivo } from "./pagoEfectivo";
import { PagarVisa } from "./pagoVisa/PagarVisa";
import { ExpiradoPowerpay, PagarPowerpay } from "./powerpay";

initializeIcons(undefined, { disableWarnings: true });
class DetallePago extends React.Component {
  state = {
    invoice: "",
    total: "",
    dinvoice: "",
    dcodigo: "",
    urlCIP: "",
    tokenFinanzas: "abcABC123",
    loading: false,
    modal: false,
    mostrarCIP: false,
    CIPObtenido: "",
    enablePE: true,
    mostrarPpVencido: false,
    sessionKey: ""
  };
  componentDidMount() {
    const parametros = retrieveQueryParams();
    if (!parametros.ms) {
      this.setState(
        {
          invoice: atob(parametros.opi[0]),
          //invoice: 47,
          jwt: parametros.tk[0],
          tv: parametros.tv[0],
          loading: true,
        },
        async () => {
          const authPayment = {
            headers: {
              Authorization: "Bearer " + this.state.jwt,
            },
          };
          
          await validarVisa(this.state.invoice, authPayment);          
          const resPaymentGet = await obtenerPago(this.state.invoice, authPayment);

          if (resPaymentGet.data.status === "NOK") {
            alert(resPaymentGet.data.message);
          }  else if (resPaymentGet.data.detail.estado === "C") {
            alert("Esta Orden de pago ya fue pagada.");
          } else if (resPaymentGet.data.detail.estado === "E") {
            await generarPension(resPaymentGet.data.detail.studentCode, this.state.invoice, authPayment);
          } else if (resPaymentGet.data.detail.estado === "P") {
            this.setState({
              studentName: resPaymentGet.data.detail.studentName,
              arrears: resPaymentGet.data.detail.arrears,
              subtotal: resPaymentGet.data.detail.subtotal,
              total: parseFloat(
                resPaymentGet.data.detail.total.replace(",", ".")
              ).toFixed(2),
              studentCode: resPaymentGet.data.detail.studentCode,
            });
            
            const resSession = await generarSessionPagoVisa(this.props.idComercio, resPaymentGet.data, this.state.tv);
            const { sessionKey } = resSession.data
            this.setState({
              sessionKey
            })
            //Generar Boton
            const form = generarBotonPagoVisa(this.state);            
            //Generar form
            const scriptEl = resSession && generarFormPagoVisa(sessionKey, this.props.idComercio, this.state.invoice, this.state.total);

            this.setState({
              loading: false,
              form,
              scriptEl
            });
          }
        }
      );
    } else {
      if (parametros.ms[0].replace("'", "").replace("'", "") === "") {
        this.props.handleConfirmar(
          parametros.od[0],
          parametros.ms[0],
          parametros.t[0],
          parametros.j[0]
        );
      } else {
        this.props.handleValidar(
          parametros.od[0],
          parametros.ms[0],
          parametros.t[0],
          parametros.j[0],
          parametros.tp[0],
          parametros.tj[0]
        );
      }
    }
  }

  handlePagoEfectivo = () => {
    this.setState(
      {
        enablePE: false,
      },
      async () => {
        const authPayment = {
          headers: {
            Authorization: "Bearer " + this.state.jwt,
          },
        };
    
        const resCIPExistente = await verificarExistenciaCIP(this.state.invoice, authPayment);
    
        if (
          resCIPExistente.data.cip.length < 1 &&
          this.state.urlCIP.length === 0
        ) {
          if (this.state.urlCIP.length < 1) {
            
            const resPagoEfectivo = await obtenerPagoEfectivo(this.state.invoice, this.state.studentCode, authPayment);

            if (resPagoEfectivo.data.state === "OK") {
              this.setState({
                urlCIP: resPagoEfectivo.data.message,
                modal: true,
                enablePE: true,
              });
            }
          }
        } else if (this.state.urlCIP.length !== 0) {
          this.setState({
            modal: true,
            enablePE: true,
            mostrarCIP: false,
          });
        } else {
          this.setState({
            CIPObtenido: resCIPExistente.data.cip,
            fechaObtenida: resCIPExistente.data.fechaVencimiento,
            mostrarCIP: true,
            enablePE: true,
          });
        }
      }
    );
  };
  
  closeModal = () => { 
    this.setState({ modal: false }); 
  };

  mostrarPowerpayVencido = () =>{
    this.setState({mostrarPpVencido: true});
  }
  
  render() {    
    return (
      <React.Fragment>
        {this.state.loading ? <div className="preloader"></div> : null}
        <Grid style={{ padding: "2rem 5rem" }}>
          <Row middle="xs" className="card">
            <Col xs={12} sm={12} className="container">
              <Row style={{ justifyContent: "Center" }}>
                <Col xs={12} sm={3} style={{ display:"flex", justifyContent: "Center", maxHeight: "160px" }}>
                  <img
                    style={{objectFit: "cover", width:"50vw", height:"100%"}}
                    src="https://upn-repositorio-public.s3.amazonaws.com/logos/png/logo-upn-sin-fondo.png"
                    alt="logo"
                  ></img>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12}>
                  <Row center="xs">
                    <Col xs={12} sm={6}>
                      <h3 className="current">Información de pago</h3>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>Nro Orden Pago</Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.invoice}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>
                    Código Estudiante
                  </Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.studentCode}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>
                    Nombre Estudiante
                  </Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.studentName}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col
                  xs={12}
                  sm={3}
                  style={{ borderTop: "solid", borderBottom: "solid" }}
                >
                  <Label style={{ fontWeight: "bold" }}>Total</Label>
                </Col>
                <Col
                  xs={12}
                  sm={3}
                  style={{ borderTop: "solid", borderBottom: "solid" }}
                >
                  <Label>S/{this.state.total}</Label>
                </Col>
              </Row>
              <br></br>
              <Row style={{ fontSize: "0.8rem", padding: "0rem 1rem" }}>
                <Col xs={12} sm={12} className="alert">
                  <label style={{ textAlign: "left !important" }}>
                    Al seleccionar PAGOEFECTIVO generarás un código CIP, con
                    este código podrás realizar el pago por el canal que desees.
                    Este código tiene una vigencia de 24 horas, al pasar este
                    tiempo se anulará.
                  </label>
                  <br></br>
                  <br></br>
                  <label style={{ textAlign: "left !important" }}>
                    ¿Cómo pagar con PagoEfectivo?
                  </label>
                  <br></br>
                  <br></br>
                  <label>
                    - Transaferencias bancarias vía PagoEfectivo - Paga en BBVA,
                    BCP, Interbank, Scotiabank, BanBif, Caja Arequipa, a través
                    de la banca por internet o banca móvil en la opción pago de
                    servicios.
                  </label>
                  <br></br>
                  <br></br>
                  <label style={{ textAlign: "left !important" }}>
                    Depósitos en efectivo vía PagoEfectivo - Paga en BBVA, BCP,
                    Interbank, Scotiabank, BanBif, Western Union, Tambo+,
                    Kasnet, Full Carga, Red Digital, Money Gram, Caja Arequipa,
                    Disashop, Banco de la Nación, Caja Sullana, Caja de los
                    Andes, Caja Paita, Caja Trujillo, Banco Azteca, Caja del
                    Santa, Caja Raíz.
                  </label>                  
                </Col>
              </Row>
              <Row center="xs">
                <PagarPagoEfectivo 
                  handlePagoEfectivo={this.handlePagoEfectivo} 
                  enablePE={this.state.enablePE}
                  modal={this.state.modal}
                  closeModal={this.closeModal}
                  urlCIP={this.state.urlCIP}
                />
                {
                  this.state.form && this.state.scriptEl ? (
                    <PagarVisa form={this.state.form} scriptEl={this.state.scriptEl} />
                  ) : null
                }
                <PagarPowerpay 
                  jwt={this.state.jwt} 
                  idOrden={this.state.invoice} 
                  studentCode={this.state.studentCode} 
                  tv={this.state.tv} 
                  mostrarPowerpayVencido={this.mostrarPowerpayVencido}
                  totalPago = {this.state.total}
                />
              </Row>
              <br></br>
              
              <ExistePagoEfectivo 
                CIPObtenido={this.state.CIPObtenido} 
                fechaObtenida={this.state.fechaObtenida}
                mostrarCIP={this.state.mostrarCIP}
              />
              
              <ExpiradoPowerpay mostrarPpVencido={this.state.mostrarPpVencido} />
              
              <br></br>
              <hr></hr>
              <br></br>
              <Row center="xs">
                <Col xs={12} sm={12}>
                  Universidad Privada del Norte - {new Date().getFullYear()}
                </Col>
              </Row>
              <br></br>
            </Col>
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export default DetallePago;
